import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export var wait = function wait(ms) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
};
export var retryOnException = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(invokeOperation, config) {
    var nextMSInterval, error, retries;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          nextMSInterval = 0;
          error = new Error('No calls made');
          retries = config.intervalsMS.length;
        case 3:
          if (!(nextMSInterval !== undefined)) {
            _context.next = 22;
            break;
          }
          _context.prev = 4;
          if (!(nextMSInterval > 0)) {
            _context.next = 9;
            break;
          }
          _context.next = 8;
          return wait(nextMSInterval);
        case 8:
          if (config.onRetry) {
            config.onRetry(error, retries - config.intervalsMS.length);
          }
        case 9:
          _context.next = 11;
          return invokeOperation();
        case 11:
          return _context.abrupt("return", _context.sent);
        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](4);
          error = _context.t0;
          if (!(config.shouldRetryOnException && !config.shouldRetryOnException(error))) {
            _context.next = 19;
            break;
          }
          throw error;
        case 19:
          nextMSInterval = config.intervalsMS.shift();
        case 20:
          _context.next = 3;
          break;
        case 22:
          throw error;
        case 23:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 14]]);
  }));
  return function retryOnException(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();